import { create } from "zustand";

const useEmployeePermissionsStore = create((set) => ({
  employeePermissions: [],
  loading: false,
  error: null,

  fetchEmployeePermissions: async (id) => {
    set({ loading: true, error: null });
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/employees/${id}/permissions`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      set({ employeePermissions: data.permissions, loading: false });
      // console.log("Employee Permissions Data", data.permissions)
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export default useEmployeePermissionsStore;
